import { render } from "./DevTools.vue?vue&type=template&id=67dd80ec&scoped=true"
import script from "./DevTools.vue?vue&type=script&lang=js"
export * from "./DevTools.vue?vue&type=script&lang=js"

import "./DevTools.vue?vue&type=style&index=0&id=67dd80ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dd80ec"]])

export default __exports__